<template>
	<section :id="['container-' + index + '-' + fileData.type]" :class="['container-' + fileData.type]">
		<div class="container-lg">
			<div class="row">
				<div class="files-title col-12">
					<h2 v-if="fileData.config.title">{{ fileData.config.title }}</h2>
				</div>
			</div>
		</div>
	
		<div class="container-lg">
			<!-- <div class="file-element"> -->
                <div class="row m-0 justify-content-center">
                    <div class="file-wrapper col-sm-12 col-md-6 col-lg-4" v-for="(file, index) in fileData.config.files" :key="index">
                        <div class="file">
                            <a :href="`${file.url}`" :title="`${file.caption}`" target="_blank">
                                <span class="file-label">{{ file.caption }}</span>
                                <svg
                                    aria-hidden="true" 
                                    focusable="false" 
                                    data-prefix="fas" 
                                    data-icon="share" 
                                    class="svg-inline--fa fa-share fa-w-16 file-icon" 
                                    role="img"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
			<!-- </div> -->
		</div>
        <hr class="horizontal-line">
	</section>
</template>

<script>
export default {
	props: {
		fileData: {
			type: Object,
		},
		index: {
			type: Number
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/filesComponent.scss";
</style>
